/*!
 * jQuery UI Participant Selector 1.0.0
 *
 * Depends:
 *	jquery.ui.core.js
 */

(function($, dom, dialog, undefined) {

	$.widget("curriculog.participantpicker", {

		// default options
		options: {
			width: 800,
			type:'basic',
			showUsers:true,
			showRoles:true,
			showRoleTypes:true,
			showOnlyCommittees:false,
			showNonCommittees: false,
			showOnlyAgendas:false,
			selectOne: true,
			selectEmpty: false,
			committeeSelector:false,
			selectNewAgendaAdmin:false,
			buttonText: 'Select Participants',
			selectText: 'Add Role(s)',
			cancelText: 'Cancel',
			roleTypeContainer: '#curriculog-steps-column-available-role-types',
			hierarchyContainer: '#curriculog-steps-column-available-roles-and-users',
      nonAdminUsersContainer: '#curriculog-steps-column-available-non-admin-users-transparency',
			dialogId: '#curriculog-steps-select-participant',
			selectorId: '#curriculog-steps-column-available-participant',
			savingToId: '',
			dbData: 'conflictReplacements',
			showAll: false,
			allButtonText: 'Select Participants for All',
			selectForAll: false,
			allButtonLabel: 'Apply to all role transfers',
			singleButtonClass: 'picker-select-button',
			allButtonClass: 'picker-all-button',
			cancelButtonClass: 'picker-cancel-button',
			selectionRequired: false
		},

		rolesNotSelectable: [],
		roleTypesNotSelectable: [],
		usersNotSelectable: [],

		rolesSelected: [],
		roleTypesSelected: [],
		usersSelected: [],
    nonAdminUsersSelected: false,

		roleTypes: [],
		roles: [],
		users: [],
		objDom: dom(),
		objDialog: dialog(),
		allClicked: false,

		_create: function() {
      var self = this;

			var button = (self.button = $('<a class="curriculog-widget add-widget" href="#" tabindex="0"></a>'))
				.attr({'title': self.element.attr('title')})
				.appendTo(self.element),

			buttonlabel = (self.buttonlabel = $('<strong></strong>'))
				.html(self.options.buttonText)
				.appendTo(button);

			// a closure to disable/enable buttons after we get removal data
			var setUpButton = function(self) {
				return function() {
					// fill in callback here
				};
			};
			// get what participants should not be selectable and then setup buttons
			self._getNonSelectables(self, setUpButton(self));

			// perform event bindings
			self._bindEvents();

		},

		_bindEvents: function() {

			var self = this;

			function clickHandler() {
				self['dialogParticipantpicker'](self);
				return false;
			}

			function keyboardHandler(e) {
				if (e.which === 13 ){
					self['dialogParticipantpicker'](self);
					return false;
				}
			}
			self.button.bind({click:clickHandler, keyup: keyboardHandler});

			if(self.options.showAll) {
				function allClickHandler() {
					self.allClicked = true;
					self['dialogParticipantpicker'](self);
					return false;
				}
				self.allButton.bind({click:allClickHandler});
			}
		},

		_setSelected: function() {
			var self = this;
			if(self.options.showRoleTypes && !self.options.showOnlyAgendas && !self.options.showOnlyCommittees) {
				$(self.options.selectorId + ' .role-type.active').each(function(index) {
					if($.inArray($(this).attr("id").replace("roleType-",""), self.roleTypes) == -1) {
						self.roleTypes.push(parseInt($(this).attr("id").replace("roleType-",""), 10));
					}

					if ($(this).attr('data-has-committee')) {
						self.agendaAvailable = true;
					}
				});
			}

			if(self.options.showRoleTypes && !self.options.showOnlyAgendas && self.options.showOnlyCommittees) {
				$(self.options.selectorId + ' .role-type.active').each(function(index) {
					if($.inArray($(this).attr("id").replace("roleType-",""), self.roleTypes) == -1) {
						self.roleTypes.push(parseInt($(this).attr("id").replace("roleType-",""), 10));
					}

					if ($(this).attr('data-has-committee')) {
						self.agendaAvailable = true;
					}
				});
			}

			if(self.options.showRoles && !self.options.showOnlyAgendas && !self.options.showOnlyCommittees) {
				$(self.options.selectorId + ' .role.active').each(function(index) {
					if($.inArray($(this).attr("id").replace("role-",""), self.roles) == -1) {
						self.roles.push(parseInt($(this).attr("id").replace("role-",""), 10));
					}

					if ($(this).attr('data-has-committee')) {
						self.agendaAvailable = true;
					}
				});
			}

			if(self.options.showUsers && !self.options.showOnlyAgendas && !self.options.showOnlyCommittees) {
				$(self.options.selectorId + ' .user.active').each(function(index) {
					if($.inArray(parseInt($(this).attr("id").replace("user-",""), 10), self.users) == -1) {
						self.users.push(parseInt($(this).attr("id").replace("user-",""), 10));
					}

					if ($(this).attr('data-has-committee')) {
						self.agendaAvailable = true;
					}
				});
			}
		},

    _saveParticipantsSwap: function(saveForAll) {
      var self = this;

      var clicked = '#' + self.button.closest('.item').attr('id');
      var clickedType = $(clicked).attr('id').match(/swap-(\w*)/)[1];

      var directParticipant = 0;
      if(clickedType == 'participant') {
        directParticipant = 1;
      }

      var originator = 0;
      if(clickedType == 'originator') {
        originator = 1;
      }

      var currentUser = $('#swap-user-id').val();
      var roleIds = [];

      if ((saveForAll !== undefined) && (saveForAll)) {
        self.element.closest('.entity-roles ').find('.item').each(function() {
          roleIds.push(parseInt($(this).attr('id').replace('swap-role-',''), 10));
        });
        clicked = '.entity-roles';
        directParticipant = 1;
        originator = 1;
        self.allClicked = false;

      } else {
        roleIds.push(parseInt(this.element.closest('.item').attr('id').replace('swap-role-',''), 10));
      }

      // get user names for DOM
      var newUsers = [];

      $.each(self.users, function(index, item) {
        // look up names by id
        var user = {
          id: item,
          name: $('.user-' + item + ':first').find('label').text()
        };
        newUsers.push(user);
      });

      $.each(roleIds, function(index, item) {
        var role = {
          id: item,
          users: newUsers
        };
      });

      accountObject.updateSwapUserDialog(currentUser, newUsers, roleIds, directParticipant, originator, function() {
      objDom.removeMask(clicked);

      self.users = [];
      self.usersNotSelectable = [];
      self.usersSelected = [];

      });

    },

    _saveParticipantsTransparency: function(saveForAll){
      var self = this;

      var id = $(self.element).attr('data-field-id');
      var data = {
        id: id,
        roleTypes: self.roleTypes,
        roles: self.roles,
        users: self.users,
        nonAdminUsers: self.nonAdminUsersSelected,
        display: 'getTransparency'
      };
      var url = '/admin/approvalProcessField:' + id + '/updateFieldTransparency.ajax';
      $.ajax({
        url: url,
        type: 'PUT',
        data: JSON.stringify(data),
        contentType: 'application/json',
        beforeSend: function(){
          objDom.addMask('.ui-dialog-content');
        },
        complete: function(){
          objDom.removeMask('.ui-dialog-content');
        },
        success: function(data){
          var selector = self.element.siblings('.type-transparency.participant-list');
          approvalProcessObject.updateFieldTransparency(selector, data);
          self.roles = [];
          self.roleTypes = [];
          self.users = [];

          self.rolesNotSelectable = [];
          self.roleTypesNotSelectable = [1];
          self.usersNotSelectable = [];

          self.rolesSelected = [];
          self.roleTypesSelected = [];
          self.usersSelected = [];

          self.nonAdminUsersSelected = false;

          Curriculog.Actions.log('ap-field-transparency-updated');
        },
        error: function(){
          $('#growls').notify('create', 'warning-template',
            {
              title: 'An Error Occured',
              text: 'Unable to update the transparency for approval process field (id: ' + id + '). Please try again or contact support.'
            },
            {expires: false}
          );
        }
      });

    },

    _saveParticipantsReport: function(saveForAll) {
      var self = this;
      var participantType = null;
      var participantId = null;
      var participantDOM = null;

      // set participant values in report
      var participantList = self.element.siblings('.participant-list');
      participantList.find('ul').empty();

      // determine what was selected
      if ( self.roles.length > 0 ) {
        participantType = 'role';
        participantId = self.roles[0];
        participantDOM = $(self.options.hierarchyContainer)
          .find('#role-' + participantId)
          .clone().attr('data-role-id', participantId).attr('id', null);
      } else if ( self.roleTypes.length > 0 ) {
        participantType = 'roleType';
        participantId = self.roleTypes[0];
        participantDOM = $(self.options.roleTypeContainer)
          .find('#roleType-' + participantId)
          .clone().attr('data-roletype-id', participantId).attr('id', null);
      } else if ( self.users.length > 0 ) {
        participantType = 'user';
        participantId = self.users[0];
        participantDOM = $(self.options.hierarchyContainer)
          .find('#user-' + participantId)
          .clone().attr('data-user-id', participantId).attr('id', null);
      }
      self._setParticipationParticipant(participantType, participantId, participantDOM);

      self.roles = [];
      self.roleTypes = [];
      self.users = [];

      self.rolesNotSelectable = [];
      self.roleTypesNotSelectable = [];
      self.usersNotSelectable = [];

      self.rolesSelected = [];
      self.roleTypesSelected = [];
      self.usersSelected = [];

      Curriculog.Actions.log('participant-report-participants-updated');
    },

    _saveParticipantsStep: function(saveForAll) {
      var self = this;

      var type = self.element.attr("class").match(/type-([A-Za-z\-]*)/);

      var id = self.element.closest('.step').attr('id').replace('step-','');

      var openNodes = [];
      self.element.closest('.step').find('.step-summary-toggle .down').each(function(index, summary) {
        openNodes.push($(summary).closest('fieldset').attr('id'));
      });

      var data = {
        id: id,
        roleTypes: self.roleTypes,
        roles: self.roles,
        users: self.users,
        type: type[1],
        display: 'getStep',
        openNodes: openNodes
      };

      // if coming from a proposal, step is a custom route
      var url = '';
      if (self.options.type === 'proposal') {
        url = '/proposal:' + id + '/pendingRoute.ajax';

        // confirm participant selections and agenda are synched
        if (! self.agendaAvailable) {
          data.agenda = 0;
        }

      } else {
        url = '/admin/approvalProcessStep:' + id + '/updateStepParticipants.ajax';
      }

      $.ajax({
        url: url,
        type: 'PUT',
        data: JSON.stringify(data),
        contentType: 'application/json',
        beforeSend: function() {
          objDom.addMask('#step-' + id);
          approvalProcessObject.unbindStepEvents();
        },
        success: function(data) {

          approvalProcessObject.getStep(data, id, self.options.type);

          self.roles = [];
          self.roleTypes = [];
          self.users = [];

          self.rolesNotSelectable = [];
          self.roleTypesNotSelectable = [];
          self.usersNotSelectable = [];

          self.rolesSelected = [];
          self.roleTypesSelected = [];
          self.usersSelected = [];

          Curriculog.Actions.log('ap-participants-updated');
        }
      });
    },


		_saveParticipants: function(saveForAll) {

			var self = this;

			self._setSelected();

			if (self.options.type === 'swap') {
        self._saveParticipantsSwap(saveForAll);
		  } else if (self.options.type === 'transparency') {
	      self._saveParticipantsTransparency(saveForAll);
		  } else if (self.options.type === 'participation-report') {
        self._saveParticipantsReport(saveForAll);
      } else {
          self._saveParticipantsStep(saveForAll);
  		}
  	},
    _setParticipationParticipant: function(participantType, participantId, participantDOM) {
      var self = this;
      var participantList = self.element.siblings('.participant-list');
      var newParticipantListItem = $('<li />').append(participantDOM);
      switch ( participantType ) {
        case 'roleType':
          participantList.append(
            $('<ul class="selected-role-types"></ul>').append(newParticipantListItem)
          );
          break;
        case 'role':
          participantList.append(
            $('<ul class="selected-roles"></ul>').append(newParticipantListItem)
          );
          break;
        case 'user':
          participantList.append(
            $('<ul class="selected-users"></ul>').append(newParticipantListItem)
          );
          break;
      }
      if (participantType && participantId) {
        participantList.find('p').removeClass('empty');
      } else {
        participantList.find('p').addClass('empty');
      }
      self.element.siblings('#report-10-participant-type').val(participantType);
      self.element.siblings('#report-10-participant-id').val(participantId);
    },

		_getNonSelectables: function(self, callback) {
			if (self.options.type == 'swap') {
					self.usersNotSelectable = [$('#swap-user-id').val()];
					callback && callback();
			}
			// can not restrict originator from viewing proposal fields
			if (self.options.type === 'transparency' ){
				self.roleTypesNotSelectable = [1];
				callback && callback();
			}
		},

		_getEntities: function(self, callback) {

			var entities = [];
			$('#restrict-entities .restricted-entity').each(function(index, item) {
				entities.push(parseInt($(item).find('.hierarchy-item').attr('id').replace('entity-',''), 10));
			});

			return entities;

		},

		_getSelected: function(self, callback) {

			if (this.options.dbData === '') {

				// based on the design of approval process step
				var selectedUL = $(this.element.closest('fieldset'));


				selectedUL.find('.hierarchy-item').each(function(index, item) {
					if($(this).hasClass('role')) {
						if (self.options.type === 'transparency' || self.options.type === 'participation-report') {
							self.rolesSelected.push(parseInt($(this).attr('data-role-id')));
						} else {
							self.rolesSelected.push(parseInt($(this).attr('id').split('-')[3], 10));
						}
					} else if($(this).hasClass('role-type')) {
						if (self.options.type === 'transparency' || self.options.type === 'participation-report') {
							self.roleTypesSelected.push(parseInt($(this).attr('data-roletype-id')));
						} else {
							self.roleTypesSelected.push(parseInt($(this).attr('id').split('-')[3], 10));
						}
					} else if($(this).hasClass('user')) {
						if (self.options.type === 'transparency' || self.options.type === 'participation-report') {
							self.usersSelected.push(parseInt($(this).attr('data-user-id')));
						} else {
							self.usersSelected.push(parseInt($(this).attr('id').split('-')[3], 10));
						}
					} else if($(this).hasClass('non-admin')) {
            self.nonAdminUsersSelected = true;
          }

				});
			}

			callback && callback();

		},

    _showNonAdminUsersSelected: function(self) {
      if ( self.nonAdminUsersSelected === true ) {
        $(self.options.nonAdminUsersContainer + ' .non-admin.participant-option').addClass('active');
      }
    },

		_showRoleTypesSelected: function(self) {

			// Add an active class to previously selected role-types.
			for (var i in self.roleTypesSelected) {
        var selectedRoleType = $(self.options.roleTypeContainer).find('#roleType-' + self.roleTypesSelected[i]);
        selectedRoleType.addClass('active');
				selectedRoleType.parents('ul').addClass('active').parentsUntil($(self.options.roleTypeContainer),'ul').addClass('active');
			}

			// Modify the toggle icon appropriately.
			$(self.options.roleTypeContainer + ' ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');

		},

		_showHierarchySelected: function(self) {

			// Add an active class to previously selected roles and users.
			for (var i in self.rolesSelected) {
				$(self.options.hierarchyContainer + ' #role-' + self.rolesSelected[i]).addClass('active');
				$(self.options.hierarchyContainer + ' #role-' + self.rolesSelected[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($(self.options.hierarchyContainer),'ul').addClass('active');
			}

			for (i in self.usersSelected) {
				$(self.options.hierarchyContainer + ' #user-' + self.usersSelected[i]).addClass('active');
				$(self.options.hierarchyContainer + ' #user-' + self.usersSelected[i]).parents('ul').addClass('active').siblings('ul').addClass('active').parentsUntil($(self.options.hierarchyContainer),'ul').addClass('active');
			}

			// Modify the toggle icon appropriately.
			$(self.options.hierarchyContainer + ' ul.active').siblings('.expand-widget').removeClass('expand-widget').addClass('contract-widget');

		},

		_disableUsersNotSelectable: function(self) {

			// disable the users who are not selectable
			for (var i in self.usersNotSelectable) {
				$(self.options.hierarchyContainer + ' #user-' + self.usersNotSelectable[i]).addClass('disabled');
			}

		},

		_disableRoleTypesNotSelectable: function(self){
			// disable role types that are not selectable
			for ( var i in self.roleTypesNotSelectable) {
				$(self.options.roleTypeContainer + ' #roleType-' + self.roleTypesNotSelectable[i]).addClass('disabled');
			}
		},

    _getNonAdminUsers: function(self) {
      var participantOption = $('<span />')
        .addClass('participant-option non-admin hierarchy-item')
        .html('<label>All Non-Admin Users</label>');
      $(self.options.nonAdminUsersContainer).contents().remove();
      $(self.options.nonAdminUsersContainer).append(participantOption);
      self._showNonAdminUsersSelected(self);
    },

		_getRoleTypes: function(self, entities) {

			var roleTypeData = {
				display: 'ajaxRoleTypeList',
				branch: JSON.stringify(entities),
				removeRoleTypes: JSON.stringify(self.roleTypesNotSelectable)
			};

			if (self.options.showRoleTypes && !self.options.showOnlyAgendas && self.options.showOnlyCommittees) {
				roleTypeData.type = 'committee';
			}

			if (self.options.showRoleTypes && !self.options.showOnlyAgendas && self.options.showNonCommittees) {
				roleTypeData.type = 'noncommittee';
			}

			$.ajax({
				url: '/roleType',
				type: 'GET',
				data: roleTypeData,
				success: function(data) {
					// Wipe out old data and load in new data.
					$(self.options.roleTypeContainer).contents().remove();
					$(self.options.roleTypeContainer).append(data);

					self._showRoleTypesSelected(self);

					self._disableRoleTypesNotSelectable(self);
					Curriculog.Actions.log('participant-picker-roletypes-loaded');
				}
			});

		},

		_getHierarchy: function(self, entities) {

			var hierarchyData = {
				display: JSON.stringify(['entities','roles','users']),
				branch: JSON.stringify(entities),
				removeUsers: JSON.stringify(self.usersNotSelectable)
			};

			if(self.options.showRoles && self.options.showUsers && !self.options.showOnlyAgendas && !self.options.showOnlyCommittees) {
				hierarchyData.removeRoles = JSON.stringify(self.rolesNotSelectable);
			}

			$.ajax({
				url: '/entity/hierarchyselector',
				type: 'GET',
				data: hierarchyData,
				success: function(data) {
					// Wipe out old data and load in new data.
					$(self.options.hierarchyContainer).contents().remove();
					$(self.options.hierarchyContainer).append(data);
					
					$(self.options.hierarchyContainer).contents().wrapAll('<li class="hierarchy-title"></li>');
					$(self.options.hierarchyContainer).contents().wrapAll('<ul></ul>');
					$(self.options.hierarchyContainer + ' .hierarchy-title').prepend('<a class="curriculog-widget expand-widget toggle-expand" href="#"></a><span class="hierarchy-item hierarchy-title"><label>Hierarchy</label></span>').removeAttr('class');

					self._showHierarchySelected(self);

					self._disableUsersNotSelectable(self);

					if(self.options.showUsers && !self.options.showRoles && !self.options.showRoleTypes) {
						$(self.options.hierarchyContainer).find('.hierarchy-item.role').each(function(index) {
							$(this).addClass('noHover');
						});
					}
					Curriculog.Actions.log('participant-picker-hierarchy-loaded');
				}
			});
		},

		_getCommitteeMembers: function(self, committeeId) {
			var committeeData = {
				committeeId: committeeId,
				returnUsers: 1,
				display: 'ajaxCommitteeList',
			};

			$.ajax({
				url: '/role/getByCommittee',
				type: 'GET',
				data: committeeData,
				success: function(data) {
					// Wipe out old data and load in new data.
					$(self.options.hierarchyContainer).contents().remove();
					$(self.options.hierarchyContainer).append(data);

					self._disableUsersNotSelectable(self);
				}
			});

		},

		dialogParticipantpicker: function(self) {

			self.roles = [];
			self.roleTypes = [];
			self.users = [];

			self.rolesNotSelectable = [];
			self.roleTypesNotSelectable = [];
			self.usersNotSelectable = [];

			self.rolesSelected = [];
			self.roleTypesSelected = [];
			self.usersSelected = [];
      self.nonAdminUsersSelected = false;

			self._getNonSelectables(self);

			// for custom route, we need to check that a role or role type
			// is present and if not, turn agenda off
			self.agendaAvailable = false;

			if(self.options.showRoles && self.options.showUsers && self.options.showRoleTypes) {
				// Click event for choosing a role-type, role, or user.
				$(self.options.dialogId).on('click', '.role-type, .role, .user', function(event) {
					event.preventDefault();
					var itemId = /role-\d+|user-\d+|role-type-\d+/i.exec($(this).attr('class'));

          if (self.options.selectOne) {
						// remove all active classes from others
						$('.user, .role-type, .role').removeClass('active');
					}

					if(self.options.selectEmpty) {
						$('.' + itemId).toggleClass('active');

					} else {
						if( (!$(this).hasClass("role-without-users")) && (!$(this).hasClass("disabled")) ) {
							$('.' + itemId).toggleClass('active');
						}
					}
				});

			} else if(!self.options.showRoles && !self.options.showRoleTypes && self.options.showUsers) {

				$(self.options.dialogId).on('click', '.user:not(.disabled)', function(event) {
					event.preventDefault();
					var itemId = /user-\d+/i.exec($(this).attr('class'));

					if (self.options.selectOne) {
						// remove all active classes from others
						$('.user').removeClass('active');
					}

					// toggle the selected one
					$('.' + itemId).toggleClass('active');
				});

			} else if(!self.options.showRoles && !self.options.showUsers && self.options.showRoleTypes) {

				$(self.options.dialogId).on('click', '.role-type', function(event) {
					event.preventDefault();
					var itemId = /role-type-\d+/i.exec($(this).attr('class'));

					if (self.options.selectOne) {
						// remove all active classes from others
						$('.role-type').removeClass('active');
					}

					// toggle the selected one
					$('.' + itemId).toggleClass('active');
				});
			}


      // Non Admin Users (currently being used in field transparency picker)
      if ( self.options.type === 'transparency' ) {
        $(self.options.dialogId).on('click', '.non-admin', function(event) {
          event.preventDefault();
          self.nonAdminUsersSelected = !self.nonAdminUsersSelected;
          $(this).toggleClass('active');
        });
      }

			// Enable/Disable buttons if selectionRequired is true
			if(self.options.selectionRequired) {
				$(self.options.dialogId).on('click', '.role-type, .role, .user', function(event) {
					event.preventDefault();
					whole_dialog = $(self.options.dialogId).parent();
					if($('.role-type.active, .role.active, .user.active', self.options.dialogId).length){
						$('.'+self.options.singleButtonClass, whole_dialog).button("option", "disabled", false);
						$('.'+self.options.allButtonClass, whole_dialog).button("option", "disabled", false);
					} else {
						$('.'+self.options.singleButtonClass, whole_dialog).button("option", "disabled", true);
						$('.'+self.options.allButtonClass, whole_dialog).button("option", "disabled", true);
					}
				});
			}

			// Click event for expanding and contracting the list of entities, roles, users, and role-types.
			$(self.options.selectorId).on('click', '.toggle-expand', function(event) {
				event.preventDefault();
				$(this).toggleClass('expand-widget').toggleClass('contract-widget').siblings('ul').toggleClass('active');
			});

			// Double click event for hierarchy items
			$(self.options.selectorId).on('dblclick', '.hierarchy-item', function(event) {
				event.preventDefault();
				var expander = $(this).siblings('.toggle-expand');
				expander.toggleClass('expand-widget').toggleClass('contract-widget').siblings('ul').toggleClass('active');
			});

			var dialog = objDialog.createDOMDialog(self.options.dialogId.replace("#", ""), function(dialog, defaults) {

				var entities = [];
				var roleIds = [];

				$(self.options.hierarchyContainer).contents().remove();

				if (self.options.type == 'swap') {

					if (self.options.selectNewAgendaAdmin) {
						self._getSelected(self, function() {
							self._getCommitteeMembers(self, $('#swap-committee-id').val());
						});

					} else {
						self._getSelected(self, function() {
							self._getRoleTypes(self, entities);
							self._getHierarchy(self, entities);
						});
					}

				} else {
					entities = self._getEntities(self);

					self._getSelected(self, function() {
						self._getRoleTypes(self, entities);
						self._getHierarchy(self, entities);
            if ( self.options.type === 'transparency' ) {
              self._getNonAdminUsers(self);
            }
					});

				}

				// disable text selection in the dialog.
				dialog.disableSelection();

				// make buttons
				var buttons = [
					{
						text: self.options.selectText,
						class: self.options.singleButtonClass,
						click: _.debounce(function() {
							self._saveParticipants();
							$(this).dialog('close');
						}, 500)
					}
				];

				if (self.options.selectionRequired) {
					buttons[0].disabled = true;
				}

				if (self.options.selectForAll) {
					selectAllButton = {
						text: self.options.allButtonLabel,
						class: self.options.allButtonClass,
						click: _.debounce(function() {
							self._saveParticipants(true);
							$(this).dialog('close');
						}, 500)
					};

					if (self.options.selectionRequired) {
						selectAllButton.disabled = true;
					}
					buttons.push(selectAllButton);
				}

				cancelButton = {
					text: self.options.cancelText,
					class: self.options.cancelButtonClass,
					click: function() { $(this).dialog('close');}
				};

				buttons.push(cancelButton);
				defaults.buttons = buttons;


				defaults.close = function() {
					// unbind events that will affect other selectors
					$(self.options.dialogId).off('click', '.role-type, .role, .user');
					$(self.options.dialogId).off('click', '.user:not(.disabled)');
					$(self.options.dialogId).off('click', '.role-type');
          $(self.options.dialogId).off('click', '.non-admin');
					$(self.options.selectorId).off('click', '.toggle-expand');
				};

				defaults.width = self.options.width;

				$(dialog).dialog(defaults);

			});
		},

		destroy: function() {

			// remove classes + data
			$.Widget.prototype.destroy.call( this );

			// remove binding
			this.button.unbind("click");
			this.allButton.unbind("click");

			// remove button
			this.button.remove();
			this.allButton.remove();

			return this;
		},

		_destroy: function() {

			// This should work for UI 1.9 but the above works for lower versions

			// remove binding
			this.button.unbind("click");
			this.allButton.unbind("click");

			// remove button
			this.button.remove();
			this.allButton.remove();
		}

	});
})(jQuery, dom, dialog);
